import { TASK_STATUS } from "@/common/constant";
import { computed, ref, watch } from "vue";
import { queryTask } from "@/service/canvas";
import { ElMessage } from "element-plus";
import { delay } from "@/common/utils";
export default (histories) => {
  // 拿到还在进行中的任务
  const pool = ref([]);

  const inProcessTasks = computed(() => {
    return histories.value.filter((item) => {
      return (
        item.code === TASK_STATUS.CREATED || item.code === TASK_STATUS.READY
      );
    });
  });

  watch(
    inProcessTasks,
    (newv) => {
      console.log(newv);
      newv.forEach((item) => {
        addTask(item);
      });
    },
    {
      deep: true,
    }
  );

  function updateTask(task) {
    const index = histories.value.findIndex(
      (item) => item.renwu_id === task.renwu_id
    );
    histories.value[index] = task;
  }

  // 添加一个任务
  async function addTask(task) {
    const { renwu_id } = task;
    // 已存在的任务不添加
    if (pool.value.find((item) => item.origin.renwu_id === renwu_id)) return;
    const queryTask = {
      loading: false,
      progressText: "",
      origin: task,
    };
    pool.value.push(queryTask);
    await delay(1000);
    querySingleTaskLoop(queryTask);
  }

  // 移除一个任务
  function removeTask(task) {
    if (!task.origin) return;
    const {
      origin: { renwu_id },
    } = task;
    pool.value = pool.value.filter((item) => {
      return item.origin.renwu_id !== renwu_id;
    });
  }

  // 轮询单个任务
  async function querySingleTaskLoop(task) {
    let {
      origin: { renwu_id },
    } = task;
    // 打开loading
    task.loading = true;
    // 查询任务
    const taskResult = await queryTask({
      renwu_id,
    });
    const taskData = taskResult.data;

    updateTask(taskData);
    if (taskResult.errno === 0) {
      const code = taskResult.data.code;
      // 出错和超时
      if (code === TASK_STATUS.FAIL || code === TASK_STATUS.TIMEOUT) {
        const reason = taskResult.data.shibai_yuanying;
        ElMessage.error(reason);
        task.progressText = "";
        task.loading = false;
        return removeTask(task);
      }
      // 显示 准备中...
      if (code === TASK_STATUS.READY) {
        task.progressText = "准备中...";
      }
      // 显示进度条
      if (code === TASK_STATUS.CREATED) {
        task.progressText = taskResult.data.jindu;
      }
      // 还在绘画中
      if (code === TASK_STATUS.READY || code === TASK_STATUS.CREATED) {
        await delay(2000);
        return querySingleTaskLoop(task);
      }
      // 绘画结束
      if (code === TASK_STATUS.SUCCESS) {
        return removeTask(task);
      }
    } else {
      return removeTask(task);
    }
    return removeTask(task);
  }
  return {
    pool,
  };
};
